module.exports = __webpack_public_path__ + "img/9788981171254.b647f8c2.jpg";